var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585205 34V48.7397C0.585205 59.3769 9.20832 68 19.8455 68H34.5852H49.3249C59.9621 68 68.5852 59.3769 68.5852 48.7397V34V19.2603C68.5852 8.62311 59.9621 0 49.3249 0H34.5852H19.8455C9.20832 0 0.585205 8.62311 0.585205 19.2603V34Z",
    fill: "#D9F7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7464 46.9604H49.8343C50.8685 46.9604 51.7068 47.7988 51.7068 48.8329C51.7068 49.8671 50.8685 50.7055 49.8343 50.7055H19.8739C18.8397 50.7055 18.0013 49.8671 18.0013 48.8329V18.8725C18.0013 17.8384 18.8397 17 19.8739 17C20.908 17 21.7464 17.8384 21.7464 18.8725V46.9604Z",
    fill: "#4AD991"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.7299 38.8794C28.0226 39.6339 26.8376 39.6721 26.0832 38.9648C25.3287 38.2575 25.2905 37.0725 25.9978 36.318L33.0198 28.8279C33.7038 28.0983 34.8405 28.035 35.6013 28.6842L41.1435 33.4135L48.3645 24.267C49.0053 23.4553 50.1828 23.3168 50.9945 23.9576C51.8062 24.5984 51.9447 25.7759 51.3039 26.5876L42.8775 37.261C42.2194 38.0947 41.0003 38.2146 40.1923 37.5251L34.5297 32.693L28.7299 38.8794Z",
    fill: "#4AD991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.5b2ed3dc201296857ee9636ca3c2a123.svg";
export { ForwardRef as ReactComponent };